export default __webpack_public_path__ + "static/media/business_partner_7.1f999a6f.png";